import './TelegramBotSheet.sass';

import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { imActions, imTelegramSelector } from '$store/im';
import { RootState } from '$store/rootReducer';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { useTranslator } from '$hooks';
import { Button, List, ListItem, LottieIcon, Placeholder } from '$uikit';
import { showModal } from '$navigation/helper';
import { mainHasBotSelector } from '$store/main';

const HOWTO_CREATE_TG_BOT =
  'https://wiki.ton.place/dlya-sozdatelei-kontenta/telegram-bot';

const TelegramBotSheetInner: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const hasBot = useSelector(mainHasBotSelector);
  // const hasBot = false;

  const handleClose = useCallback(() => {
    dispatch(imActions.setTelegramSheetVisible(false));
  }, []);

  const handleCreatePost = useCallback(() => {
    dispatch(imActions.setTelegramSheetVisible(false));
    showModal('create_invoice', false, {
      peer_id: 0,
      type: 'tg',
    });
  }, []);

  return (
    <BottomSheet
      className="TelegramBotSheet"
      title={hasBot ? t('tg_bot_title') : ''}
      onClose={handleClose}
    >
      {hasBot ? (
        <List className="TelegramBotSheet__list">
          <ListItem
            chevron
            description={t('tg_bot_paid_post_desc')}
            onClick={handleCreatePost}
          >
            {t('tg_bot_paid_post_title')}
          </ListItem>
        </List>
      ) : (
        <Placeholder
          iconSize={160}
          className="TelegramBotSheet__withoutBotPlaceholder"
          icon={<LottieIcon size={160} name="robot" />}
          title={t('tg_bot_placeholder_title')}
          actions={
            <a target="_blank" href={HOWTO_CREATE_TG_BOT} rel="noreferrer">
              <Button>{t('tg_bot_create_bot_button')}</Button>
            </a>
          }
        >
          {t('tg_bot_placeholder_desc')}
        </Placeholder>
      )}
    </BottomSheet>
  );
};

export const TelegramBotSheet: FC = () => {
  const isSheetVisible = useSelector(
    (state) => imTelegramSelector(state as RootState).isTelegramSheetVisible,
  );
  if (!isSheetVisible) {
    return null;
  }

  return <TelegramBotSheetInner />;
};
